
import { styled } from '@mui/material/styles';

// Components
import { FormControl, InputLabel, Badge, Select, MenuItem } from '@mui/material';

// Icons
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";

import { MediaQuerys } from "../../../styles/GlobalStyle";
import { useColors } from '../../../Context/ColorsContext';

const { tablet, desktop } = MediaQuerys;


export const ContainerFilters = styled('form')(({ activeswitch, theme }) => {
    return {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        gap: '0.80rem',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: '14px',
        [theme.breakpoints.down('md')]: {
            justifyContent: activeswitch && 'start',
            flexWrap: 'wrap',
        }
    }
});


export const CleanIcon = styled(CleaningServicesIcon)(() => {
    const { colors } = useColors();
    return {
        color: colors.white,
        fontSize: 18,
        [tablet]: {
            width: 17,
            height: 17,
            padding: '1px',
            '.MuiSvgIcon-root': {
                width: 16,
                height: 16,
            }
        },
        [desktop]: {
            width: '16px',
            height: '16px',
        }
    };
});

export const ContainerSearch = styled("div")(() => ({
    display: "flex",
    flexDirection: "row",
    gap: "0.80rem",
    alignItems: "center",
}));

export const ContainerGroup = styled("div")(({ needMagin }) => {
    return {
        display: "flex",
        alignItems: "center",
        gap: "0.50rem",
        flexDirection: "row",
        marginLeft: needMagin && 5,
    };
});

export const CustomFormControl = styled(FormControl)(({ theme }) => {
    return {
        width: "100%"
    };
});

export const CustomInputLabel = styled(InputLabel)(() => {
    return {
        fontSize: "14px",
        position: "absolute",
        top: "50%",
        left: "40%",
        transform: "translate(-50%, -50%)",
        [tablet]: {
            fontSize: "12px",
        }
    };
});

export const CustomBadge = styled(Badge)(() => {
    return {
        color: "white",
        [desktop]: {
            "& .MuiBadge-badge": {
                minWidth: "15px !important",
                width: "15px !important",
                height: "15px !important",
            },
            fontSize: "0.75rem",
        },
    };
});

export const CustomSelect = styled(Select)(() => {
    return {
        width: "150px",
        height: "32px",
        [desktop]: {
            width: "110px",
        },
        [tablet]: {
            width: "120px",
            height: 26,
        },
    };
});

export const CustomMenuItem = styled(MenuItem)(() => {
    return {
        // '& .MuiList-root': {
        //     paddingTop: '0px !important',
        // },
        // '& .MuiFormControl-root': {
        //     marginTop: '8px !important',
        // },
        [desktop]: {
            "& .MuiTypography-root": {
                fontSize: "0.75rem",
            },
        },
    };
});

export const ContainerSelects = styled('div')(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "row",
        gap: '0.80rem',
        [theme.breakpoints.down('md')]: {
            flexWrap: 'wrap',
        }
    }
});